import React from 'react';
import styled from 'styled-components';
import WeekList from './WeekList.jsx';
import {device} from '../MainContents/Style/StyleDevice';

const TableWhitespace = styled.div`
    padding: 30px 0px 30px;
    margin: 30px 0px 30px;
`;

const TableWhitespaceColor = styled(TableWhitespace)`
    background-color: whitesmoke;
`;

const TableElementCenter = styled.td`
    height: 50px;
    vertical-align: middle!important;
`;

const CourseOption = styled.p`
    padding-left: 15px;
    line-height: 1.8;
`;

const CourseIntroduction = styled.p`
    padding-left: 15px;
    color: red;
    font-size: 25px;
    font-weight: bold;
`;

const Margin = styled.div`
    margin: 30px 0px 30px;
`;

const TableMarginWid = styled.table`
    width: 90%;
    margin: auto;
    table-layout: fixed;
    word-wrap: break-word;
    display: table;
    
    @media ${device.laptop}{
        display: block !important;
    }
`;

const SpecialNote = styled.div`
    background-color: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 15px;
    margin: 15px;
    border-radius: 4px;
    
    p {
        margin: 5px 0;
        line-height: 1.6;
    }
`;

const CourseTable = (props) => {
    const id = props.id;
    const weekdays = ['', '月', '火', '水', '木', '金', '土'];
    
    return (
        <Margin>
            {/* 新小学3年生 YTクラス 3-2教室 */}
            {id === '1' &&
                <TableWhitespace>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                    <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                        <tbody>
                            <WeekList weekdays={weekdays} />
                            <tr>
                                <td>17:30～18:15</td>
                                <td></td>
                                <td>算数</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <TableElementCenter>算数<br/>13:50～14:35</TableElementCenter>
                            </tr>
                            <tr>
                                <td>18:20～19:05</td>
                                <td></td>
                                <td>国語</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <TableElementCenter>国語<br/>13:00～13:45</TableElementCenter>
                            </tr>
                        </tbody>
                    </TableMarginWid>
                    <CourseOption style={{fontWeight: 'bold', color: 'red'}}>
                        {props.detailComment}
                    </CourseOption>
                    <CourseOption>{props.detailComment2}</CourseOption>
                    <CourseOption>{props.detailComment3}</CourseOption>
                </TableWhitespace>
            }

            {/* 新小学4年生 YTクラス 3-1教室 */}
            {id === '2' &&
                <TableWhitespaceColor>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                    <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                        <tbody>
                            <WeekList weekdays={weekdays} />
                            <tr>
                                <td>17:30～18:15</td>
                                <TableElementCenter rowSpan="3">算数個別補習</TableElementCenter>
                                <td>社会</td>
                                <td>社会</td>
                                <td></td>
                                <td>算数</td>
                                <TableElementCenter rowSpan="5">
                                    算数個別指導<br/>
                                    13:00～16:15
                                </TableElementCenter>
                            </tr>
                            <tr>
                                <td>18:20～19:05</td>
                                <td>算数</td>
                                <td>理科</td>
                                <td></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>19:10～19:55</td>
                                <td>算数</td>
                                <td>理科</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>20:00～20:45</td>
                                <td></td>
                                <td>国語</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>20:50～21:20</td>
                                <td></td>
                                <td>社会個別補習</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>16:50～17:35</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>17:40～18:25</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>18:30～19:15</td>
                                <td colSpan="5"></td>
                                <td>社会</td>
                            </tr>
                            <tr>
                                <td>19:20～20:05</td>
                                <td colSpan="5"></td>
                                <td>理科</td>
                            </tr>
                        </tbody>
                    </TableMarginWid>
                    <SpecialNote>
                        <p><strong>通常の土曜日:</strong> 13:00～16:15 算数個別指導、16:50～20:05 通常授業</p>
                        <p><strong>四谷組分けテスト:</strong> 午後受験、テスト後に算数の解説授業(15:30～16:45)</p>
                        <p><strong>土佐塾テスト:</strong> 午前受験、当日の個別補習はありません</p>
                    </SpecialNote>
                    <CourseOption>{props.detailComment}</CourseOption>
                </TableWhitespaceColor>
            }

            {/* 新小学5年生 YTクラス 2-2教室 */}
            {id === '3' &&
                <TableWhitespace>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                    <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                        <tbody>
                            <WeekList weekdays={weekdays} />
                            <tr>
                                <td>17:30～18:15</td>
                                <TableElementCenter rowSpan="3">算数個別補習</TableElementCenter>
                                <td>理科</td>
                                <td>国語</td>
                                <td></td>
                                <td>社会</td>
                                <TableElementCenter rowSpan="5">
                                    理科個別指導<br/>
                                    13:00～16:45
                                </TableElementCenter>
                            </tr>
                            <tr>
                                <td>18:20～19:05</td>
                                <td>理科</td>
                                <td>社会</td>
                                <td></td>
                                <td>国語</td>
                            </tr>
                            <tr>
                                <td>19:10～19:55</td>
                                <td>社会</td>
                                <td>算数</td>
                                <td></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>20:00～20:45</td>
                                <td>算数ハイレベル特訓</td>
                                <td>算数</td>
                                <td></td>
                                <td></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>20:50～21:20</td>
                                <td></td>
                                <td></td>
                                <td>国語個別補習</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>16:20～16:45</td>
                                <td colSpan="5"></td>
                                <td>軽食Time</td>
                            </tr>
                            <tr>
                                <td>16:50～17:35</td>
                                <td colSpan="5"></td>
                                <td>理科</td>
                            </tr>
                            <tr>
                                <td>17:40～18:25</td>
                                <td colSpan="5"></td>
                                <td>理科</td>
                            </tr>
                            <tr>
                                <td>18:30～19:15</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>19:20～20:05</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                        </tbody>
                    </TableMarginWid>
                    <SpecialNote>
                        <p><strong>通常の土曜日:</strong> 13:00～16:45 理科個別指導、16:50～20:05 通常授業</p>
                        <p><strong>四谷組分けテスト:</strong> 午後受験、当日の午後の個別補習はありません</p>
                        <p><strong>土佐塾テスト:</strong> 午前受験、午後から授業(12:45～16:00)、当日の個別補習はありません</p>
                    </SpecialNote>
                    <CourseOption>{props.detailComment}</CourseOption>
                </TableWhitespace>
            }

            {/* 新小学6年生 YTクラス 2-1教室 */}
            {id === '4' &&
                <TableWhitespaceColor>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                    <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                        <tbody>
                            <WeekList weekdays={weekdays} />
                            <tr>
                                <td>17:30～18:15</td>
                                <TableElementCenter rowSpan="3">算数個別補習</TableElementCenter>
                                <td>算数</td>
                                <td>算数</td>
                                <td></td>
                                <td>国語</td>
                                <TableElementCenter rowSpan="5">
                                    算数個別指導<br/>
                                    13:00～16:45
                                </TableElementCenter>
                            </tr>
                            <tr>
                                <td>18:20～19:05</td>
                                <td>社会</td>
                                <td>算数</td>
                                <td></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>19:10～19:55</td>
                                <td>理科</td>
                                <td></td>
                                <td></td>
                                <td>社会</td>
                            </tr>
                            <tr>
                                <td>20:00～20:45</td>
                                <td>算数ハイレベル特訓</td>
                                <td>理科</td>
                                <td>社会</td>
                                <td></td>
                                <td>国語</td>
                            </tr>
                            <tr>
                                <td>20:50～21:20</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>算数個別補習</td>
                            </tr>
                            <tr>
                                <td>16:20～16:45</td>
                                <td colSpan="5"></td>
                                <td>軽食Time</td>
                            </tr>
                            <tr>
                                <td>16:50～17:35</td>
                                <td colSpan="5"></td>
                                <td>理科</td>
                            </tr>
                            <tr>
                                <td>17:40～18:25</td>
                                <td colSpan="5"></td>
                                <td>理科</td>
                            </tr>
                            <tr>
                                <td>18:30～19:15</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                            <tr>
                                <td>19:20～20:05</td>
                                <td colSpan="5"></td>
                                <td>算数</td>
                            </tr>
                        </tbody>
                    </TableMarginWid>
                    <SpecialNote>
                        <p><strong>通常の土曜日:</strong> 13:00～16:45 算数個別指導、16:50～20:05 通常授業</p>
                        <p><strong>四谷組分けテスト:</strong> 午後受験、当日の午後の個別補習はありません</p>
                        <p><strong>土佐塾テスト:</strong> 午前受験、午後から授業(12:45～16:00)、当日の個別補習はありません</p>
                    </SpecialNote>
                    <CourseOption>{props.detailComment}</CourseOption>
                </TableWhitespaceColor>
            }
        </Margin>
    );
};

export default CourseTable;
